const radioToggle = document.querySelectorAll('.dimension_toggle_wrapper')
radioToggle.forEach(item => {
    item.addEventListener('click', function(){
        if(item.classList.contains('meter')){
            document.querySelector('.square_meter_area').style.display = "block";
            document.querySelector('.width_length_area').style.display = "none";
        }else{
           document.querySelector('.square_meter_area').style.display = "none";
            document.querySelector('.width_length_area').style.display = "block"; 
        }
    })
})






function formatPriceInEuroStyle(price) {
  const currencyCode = getShopifyCurrencyCode();
  const formattedPrice = price.toLocaleString('de-DE', {
    style: 'currency',
    currency: currencyCode,
  });

  return formattedPrice;
}

function getShopifyCurrencyCode() {
  return 'EUR'; 
}

// Example usage


(function($) {

        // DATA

        var squareValueInput = '#square_meter_input';
        var squareValue = $('#square_meter_input').val();
        var feetUnit = 1.196;
        var boxContainsText = '#box_contains';
        var boxContains = parseFloat($('#box_contains').text());
        var boxAmount = '#box_amount';
        var totalPrice = '.final_price';
        var totalPriceValue = parseFloat($('.final_price').text());
        var totalQty = '#row_2 .col.one input.quantity__input';
        var buttonQtyAttr = '.product-form__submit';
        var feetValue = boxContains * feetUnit;
        var plusBtn = '#row_2 .plusBtn';
        var minusBtn = '#row_2 .minusBtn';
      var totalExtend = $('.final_price').data('product-price')
         var priceInEuro, formattedPrice;

        // RESTRICT 0 OR EMPTY VALUE
        $('input[type="number"]').bind('keyup change', function() {
            if ($(this).val() === '0') {
                $(this).val('1');
            } else if ($(this).val().length == '0') {
                $(buttonQtyAttr).addClass('disabled')
            } else {
                $(buttonQtyAttr).removeClass('disabled')
            }
        })


        // ON CHANGE SQUARE METER CALCULATIONS

        $(squareValueInput).bind('keyup change', function() {
            if ($('#square_toggle:checked').length) {
                var squareValue = $('#square_meter_input').val();
                var totalBoxes = Math.ceil(squareValue / feetValue).toFixed(0);
                $(boxContainsText).text((totalBoxes * feetValue).toFixed(2));

            } else {
                var squareValue = $('#square_meter_input').val();
                var totalBoxes = Math.ceil(squareValue / boxContains).toFixed(0);
                $(boxContainsText).text((totalBoxes * boxContains).toFixed(2));

            }

            // New Total Boxes Values
            $(totalQty).val(totalBoxes);
            $(boxAmount).text(totalBoxes);

             
             priceInEuro = totalBoxes * totalExtend /100;
            formattedPrice = formatPriceInEuroStyle(priceInEuro)

             $(totalPrice).text(formattedPrice.replace('€', ''));
            $(buttonQtyAttr).attr('data-quantity', totalBoxes);
              console.log(feetValue);
        });


        $(totalQty).bind('keyup change', function() {
            $(boxContainsText).text(($(this).val() * boxContains).toFixed(2));
            // New Total Boxes Values
             priceInEuro = $(this).val() * totalExtend /100;
            formattedPrice = formatPriceInEuroStyle(priceInEuro)
            $(boxAmount).text($(this).val());
           $(totalPrice).text(formattedPrice.replace('€', ''));
            $(buttonQtyAttr).attr('data-quantity', $(this).val());
        });


        $('#length, #width').bind('keyup change', function() {
            var widthDim = $('#width').val();
            var lengthDim = $('#length').val();
            var squaredWL = widthDim * lengthDim;

            $(squareValueInput).val(squaredWL).change();

        })

    })(jQuery)



